module.exports = __webpack_public_path__ + "static/media/background-header@2x.ba8d4767.jpg";